import * as React from 'react';
import { Grid, Row, Col } from 'react-styled-flexboxgrid';
export const Logos: React.FC = () => {
  return (
    <Grid>
      <Row style={{ margin: '32px 0px' }}>
        <Col
          md={12}
          sm={12}
          xs={12}
          style={{
            display: 'flex',
            justifyContent: 'space-around',
            paddingBottom: '32px',
          }}
        >
          <img
            src="https://cdn.getwaterfit.co.uk/static/files/images/gwf-business/logos/twrc_logo.png"
            alt="The water retail company"
            height="61px"
          />
          <img
            src="https://cdn.getwaterfit.co.uk/static/files/images/gwf-business/logos/logo-wave.png"
            alt="Wave"
            height="61px"
          />
          <img
            src="https://cdn.getwaterfit.co.uk/static/files/images/gwf-business/logos/everflow.png"
            alt="Everflow"
            height="61px"
          />
          <img
            src="https://cdn.getwaterfit.co.uk/static/files/images/gwf-business/logos/sfb.png"
            alt="SfB"
            height="61px"
          />
          <img
            src="https://cdn.getwaterfit.co.uk/static/files/images/gwf-business/logos/pe-color.png"
            alt="PE"
            height="61px"
          />
          <img
            src="https://cdn.getwaterfit.co.uk/static/files/images/gwf-business/logos/essex.png"
            alt="Essex and Suffolk"
            height="61px"
          />
        </Col>
        <Col
          md={12}
          xs={12}
          sm={12}
          style={{ display: 'flex', justifyContent: 'space-around' }}
        >
          <img
            src="https://cdn.getwaterfit.co.uk/static/files/images/gwf-business/logos/aws_horizontal_logo.png"
            alt="Anglian water"
            height="61px"
          />
          <img
            src="https://cdn.getwaterfit.co.uk/static/files/images/gwf-business/logos/castle-water.png"
            alt="Castle water"
            height="61px"
          />
          <img
            src="https://cdn.getwaterfit.co.uk/static/files/images/gwf-business/logos/cam-logo.png"
            height="61px"
            alt="Cambridge water"
          />
          <img
            src="https://cdn.getwaterfit.co.uk/static/files/images/gwf-business/logos/affinity.png"
            alt="Affinity water"
            height="61px"
          />
          <img
            src="https://cdn.getwaterfit.co.uk/static/files/images/gwf-business/logos/matrixgroup-color.png"
            alt="Matrix Group"
            height="61px"
          />
        </Col>
      </Row>
    </Grid>
  );
};

export default Logos;
